export default "/images/93fc78211d42a4b4cd4a4f6503a9203e.png";